export default {"src":"/_next/static/media/13-icon.2931b81f.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};